import React, { useState, useEffect, useMemo } from 'react'
import { useHistory } from 'react-router';
import { ButtonPrimary, ButtonPrimarySm } from '../../components/formelements';
import { getSession, valdiatePage } from '../../global';
import { voidCNs } from '../../services/bookingservice';
import { getNonVoidCNs } from '../../services/reportservice';
import { getLocations, getSubAccountLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../components/paginations';



const VoidConsignments = () => {
    const dispatch = useDispatch();
    const { userInfo, loading, subaccounts } = useSelector(state => state.appData);

    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const d = {
        subAccountId: '',
        locationId: '',
        from: today,
        to: today
    };

    const [data, setData] = useState(d);
    const [locations, setLocations] = useState([]);
    const [grid, setGrid] = useState([]);
    const history = useHistory();

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        cn: '',
        consignee: '',
        refNo: '',
        bookingDate: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {
            key: '', 
            name: <input className="form-check-input" type="checkbox" checked={grid.length === grid.filter(y => y.selected).length} onChange={(e) => {
                const g = grid.map(y => {
                    return { ...y, selected: e.target.checked }
                });
                setGrid(g);
            }} />, 
            searchBox: false, 
            visible: true
        },
        {key: 'cn', name: 'Consignment No', searchBox: true, visible: true},
        {key: 'consignee', name: 'Consignee', searchBox: true, visible: true},
        {key: 'pcs', name: 'Pieces', searchBox: false, visible: true},
        {key: 'weight', name: 'Weight', searchBox: false, visible: true},
        {key: 'refNo', name: 'Reference No', searchBox: true, visible: true},
        {key: 'bookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {
            key: '', 
            name: <ButtonPrimarySm text="Combined Mark Void" onClick={async () => {
                if (window.confirm('Are you sure?')) {
                    const selectedCNs = grid.filter(c => c.selected).map(c => c.cn);
                    if (selectedCNs.length > 0) {
                        dispatch(setLoading({ data: true }))
                        const rs = await voidCNs(selectedCNs);
                        dispatch(setLoading({ data: false }))
                        alert(rs.msg);
                        if (rs.ok) {
                            setGrid(grid.filter(c => !c.selected));
                        }
                    } else {
                        alert('Select Consignments');
                    }
                }
            }} />, 
            searchBox: false, 
            visible: true
        }
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (valdiatePage('/addresslabel')) {

        } else {
            history.push('/login');
        }
        return () => {

        }
    }, []);

    const updateData = (key, val) => setData(prevState => { return { ...prevState, [key]: val }; });

    const updateGrid = (index, key, val) => {
        let g = [...grid];
        g[index][key] = val;
        setGrid(g);
    }

    const onSearch = async () => {

        if (!data.subAccountId) {
            alert('Select Sub Account');
            return;
        }

        if (!data.locationId) {
            alert('Select Location');
            return;
        }

        if (!data.from) {
            alert('Select Order From Date');
            return;
        }

        if (!data.to) {
            alert('Select Order To Date');
            return;
        }

        if (Date.parse(data.from) > Date.parse(data.to)) {
            alert('Invalid Date Range');
            return;
        }

        dispatch(setLoading({ data: true }))
        const rs = await getNonVoidCNs({ ...data, locationId: [data.locationId] });
        dispatch(setLoading({ data: false }))
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            } else {
                alert('No Record Found');
            }
        } else {
            alert(rs.msg);
        }
    }

    const onMarkVoid = async (index, x) => {
        if (window.confirm('Are you sure?')) {
            dispatch(setLoading({ data: true }))
            const rs = await voidCNs([x.cn]);
            dispatch(setLoading({ data: false }))
            alert(rs.msg);
            if (rs.ok) {
                const g = [...grid];
                g.splice(index, 1)
                setGrid(g);
            }
        }
    }

    return getSession('userInfo') && <section className="section">
        <div className="section-header">
            <h1>Void Consignments</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-2">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        if (val) {
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            setData({ ...data, subAccountId: val, locationId: '' });
                            const locs = await getSubAccountLocations(userInfo.id, val)
                            if (locs)
                                setLocations(locs);
                        } else {
                            setLocations([]);
                        }
                    }}>
                        <option value="" data-accno="">Select Sub Account</option>
                        {
                            subaccounts.map((x, index) => <option key={index} value={x.id} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Order From</label>
                    <input type="date" className="form-control" value={data.from} onChange={(e) => updateData('from', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Order To</label>
                    <input type="date" className="form-control" value={data.to} onChange={(e) => updateData('to', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <ButtonPrimary text="Search" onClick={onSearch} disabled={loading} style={{ marginTop: '1.5rem' }} />
                </div>
            </div>

            <br />
            {
                originalGrid.length > 0 &&
                    <Pagination
                        setGrid={setGrid}
                        searchObjInit={searchObjInit}
                        searchObject={searchObject}
                        originalGrid={originalGrid}
                        setPage={setPage}
                        setPageLimit={setPageLimit}
                        requestSort={requestSort}
                        sortConfig={sortConfig}
                        updateSearchData={updateSearchData}
                        sortedArray={sortedArray}
                        data={data}
                        dataCount={grid.length}
                        pageLimit={pageLimit}  
                        gridKeys={gridKeys}
                        page={page}
                        grid={
                        sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                            <tr key={index}>
                                <td>{(index + 1)+(page*pageLimit)}</td>
                                <td style={{ position: 'relative' }}>
                                    <input className="form-check-input" checked={x.selected} type="checkbox" onChange={(e) => {
                                        let objIndex = -1;
                                        for (let i = 0; i < grid.length; i++) {
                                            if (grid[i]['cn'] === x.cn) {
                                                objIndex = i;
                                                break;
                                            }
                                        }
                                        updateGrid(objIndex, 'selected', e.target.checked)
                                    }} />
                                </td>
                                <td>{x.cn}</td>
                                <td>{x.consignee}</td>
                                <td>{x.pcs}</td>
                                <td>{x.weight}</td>
                                <td>{x.refNo}</td>
                                <td>{x.bookingDate}</td>
                                <td>
                                    <ButtonPrimarySm text="Mark Void" onClick={() => {
                                        let objIndex = -1;
                                        for (let i = 0; i < grid.length; i++) {
                                            if (grid[i]['cn'] === x.cn) {
                                                objIndex = i;
                                                break;
                                            }
                                        }
                                        onMarkVoid(objIndex, x)
                                    } } />
                                </td>
                            </tr>)
                    }
                />
            }
        </div>
    </section>
}

export default VoidConsignments;
